import { Chip } from "@mui/material";

export default function ColouredSuitLogo({ suit }: { suit: string }) {
  const getSuitIcon = (suit: string) => {
    switch (suit.toLowerCase()) {
      case "heart":
        return <span style={{ color: "#7c3aed" }}>❤️</span>;
      case "spade":
        return <span style={{ color: "#0f172a" }}>♠️</span>;
      case "diamond":
        return <span style={{ color: "#3b82f6" }}>♦️</span>;
      case "clover":
      case "pclub":
        return <span style={{ color: "#16a34a" }}>♣️</span>;
      default:
        return <span>🎴</span>;
    }
  };
  return (
    <Chip
      label={suit}
      icon={getSuitIcon(suit)}
      sx={{
        backgroundColor: "var(--primary-100)",
        font: "var(--body-xs)",
        color: "var(--neutral-1000)",
        borderRadius: "16px",
        padding: { xs: "5px", md: "6px" },
        maxHeight: { xs: "23px", md: "28px" },
        ".MuiChip-label": {
          padding: { xs: "10px", md: "12px" },
          height: "100%",
          display: "flex",
          alignItems: "center",
        },

        // height: {
        //    xs: "auto",
        //    sm: "auto",
        //   md: "28px",
        // },
        fontSize: {
          xs: "10px",
          sm: "12px",
        },
      }}
    />
  );
}
